import { LOADER } from '../../reduxs'

const initialState = {
  isDisplay: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADER.actionType.DISPLAY_LOADER :
      return { ...state, isDisplay: action.status }
    default :
      return state
  }
}
